import axios from "axios";
import { routes } from "../utils/mappers";
import {
  createProductFormData,
  createUpdateEntrepreneurFormData,
} from "../utils/payloads";

const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PORTAL_BASE_URL_PRO
    : process.env.REACT_APP_PORTAL_BASE_URL_DEV;



const baseURL2 = process.env.REACT_APP_CACADORES_BASE_URL_PRO;
// const baseURL = "http://mercadim.ifce.edu.br/";

export const api = axios.create({
  baseURL: baseURL + "api",
  headers: {
    Accept: "application/json",
  },
});

export const api2 = axios.create({
  baseURL: baseURL2 + "api",
  headers: {
    Accept: "application/json",
  },
});

// export const apiPDF = axios.create({
//   baseURL: "http://localhost:8000/api",
//   headers: {
//     Accept: "application/pdf"
//   }
// })










export async function searchProductInCityCategory(
  data,
  page = 1,
  ascOrDesc = "DESC"
) {
  const result = await api2.post("/searchProductInCity", data, {
    params: {
      page,
      ascOrDesc,
    },
  });
  return result.data;
}

export async function getAllCategories(page = 1) {
  const result = await api2.get("/categories", {
    params: {
      page,
    },

  });
  return result.data.categories;
}


export function setBearerToken(token) {
  api.defaults.headers.Authorization = `Bearer ${token}`;
  // apiPDF.defaults.headers.Authorization = `Bearer ${token}`;
}

export function clearBearerToken() {
  delete api.defaults.headers.Authorization;
  // delete apiPDF.defaults.headers.Authorization;
}

export async function signupUser(user, type) {
  const response = await api.post(routes.signup[type], user);

  return response.data;
}

export async function loginUser(user, type) {
  const response = await api.post("/login", user);

  return response.data;
}

export async function loginGoogle(user) {
  const response = await api.post("/loginGoogle", user);

  return response.data;
}

export async function AddUser(data) {
  const result = await api.post("/user", data);

  return result.data;
}
export async function updateUser(user) {
  const id = user.id;

  if (user.password.length === 0) {
    delete user.password;
  }

  let status = false;

  await api.post(`/user/update/${id}`, user).then(
    (res) => {
      if (res.data.id) {
        status = true;
      }
    },
    (err) => {
      // const msg = Object.values(err.response.data.erros).map((m) =>
      //   m.toString()
      // );
      status = false;
    }
  );
  return status;
}
export async function getAllAdmins(page = 1) {
  const result = await api.get("/admins", { params: { page } });
  return result.data;
}

export async function getAdmin(id) {
  const result = await api.get(`/admin/${id}`);

  return result.data;
}

//Cadastrando uma admin
export async function AddAdmin(data) {
  const result = await api.post("/admin", data);

  return result.data;
}

//Deletando um admin
export async function deleteAdmin(user) {
  try {
    await api.delete(`/admin/delete/${user.id}`);
  } catch (err) { }
}

// Pegando todos os usuários
export async function getAllUsers(page = 1) {
  const result = await api.get("/users", {
    params: { page },
  });

  return result.data;
}

//Pegando um usuário
export async function getUser(id) {
  const result = await api.get(`/user/${id}`);

  return result.data;
}

export async function searchUser(query, page = 1) {

  const isCPF = /^\d{11}$/.test(query);

  if (isCPF) {
    try {
      const result = await api.post("/user/cpf", { cpfUser: query });
      return { data: [result.data] };
    } catch (err) {
      return { data: [] };
    }
  } else {
    const result = await api.post("/user/search", { nameUser: query, page });
    return result.data;
  }
}

export async function searchAdmin(query, page = 1) {
  // name only
  const result = await api.post("/admin/search", {
    nameAdmin: query,
    page,
  });

  return result.data;
}



export async function getGeneralRole() {
  const result = await api.get("/roleGeneral");

  return result.data;
}

export async function logoutUser(role) {
  await api.post(routes.logout[role]);
}

export async function AddEditor(data) {
  const result = await api.post("/editor", data);

  return result.data;
}

export async function deleteEditor(user) {
  try {
    await api.delete(`/editor/delete/${user.id}`);
  } catch (err) { }
}
export async function getAllEditors(page = 1) {
  const result = await api.get(`/editors`, { params: { page } });
  return result.data;
}

export async function searchEntrepreneur(query, page = 1) {
  // name only
  const isCNPJ = /^\d{14}$/.test(query);
  const isCPF = /^\d{11}$/.test(query);

  if (isCPF || isCNPJ) {
    try {
      const result = await api.post("/entrepreneur/cpfcnpj", {
        cpf_cnpj: query,
      });
      return { data: result.data };
    } catch (err) {
      return { data: [] };
    }
  } else {
    const result = await api.post("/entrepreneur/search", {
      name_establishment: query,
      page,
    });

    return result.data;
  }
}
























export async function getDashboardAdmin(month, year) {
  const result = await api.post("/dashboard/admin", {
    year,
    month,
  });

  return result.data;
}





export async function getDashboardAdminFilterByMonthYear(month, year) {
  const result = await api.post("/dashboard/admin/filterByMonthYear", {
    year,
    month,
  });

  return result.data;
}























export async function updateAdmin(admin) {
  try {
    await api.post(`/admin/update/${admin.id}`, admin);

    return { updated: true };
  } catch (err) {
    return { updated: false };
  }
}

//Deletando um usuário
export async function deleteUser(user) {
  try {
    await api.delete(`/user/delete/${user.id}`);
  } catch (err) { }
}

export async function getCidades(uf) {
  const result = await api.get(`/citys/${uf}`);
  console.log(result.data);
  return result.data;
}

// Solicita a recuperação de senha
export async function forgotPassword(email) {
  const result = await api.post("/forgot", {
    email: email,
  });
  return result.data;
}

// Atualiza a senha
export async function newPassword(data) {
  const result = await api.post("/newPassword", data);
  return result.data;
}

export async function getEditor(id) {
  const result = await api.get(`/editor/${id}`);

  return result.data;
}

export async function updateEditor(user) {
  try {
    await api.post(
      `/editor/update/${user.id}`,
      createUpdateEntrepreneurFormData(user)
    );

    return { updated: true };
  } catch (err) {
    return { updated: false };
  }
}

export async function getAllLocations(page = 1) {
  const result = await api.get("/citys", {
    params: {
      page,
    },
  });

  return result.data;
}

export async function searchLocation(query, page = 1) {
  const result = await api.post("/city/search", { nameCity: query, page });
  return result.data;
}

export async function getAllCategorisAdmin(page = 1) {
  const result = await api.get("/allCategorysAdmin", {
    params: {
      page,
    },

  });
  return result.data.categories;

}

export async function getAllTypes(page = 1) {
  const result = await api.get("/typeAll", {
    params: {
      page,
    },
  });

  return result.data
}

export async function category(data) {
  const result = await api.post("/category", data);

  return result.data;
}

export async function typeAdd(data) {
  const result = await api.post("/typeCad", data);

  return result.data;
}

export async function deleteCategory(cat) {
  try {
    await api.delete(`/categories/delete/${cat.id}`);
  } catch (err) { }
}

export async function deleteType(type) {
  try {
    await api.delete(`/typeDelete/${type.id}`);
  } catch (err) { }
}

export async function getCategory(id) {
  const result = await api.get(`/category/${id}`);

  return result.data;
}

export async function getType(id) {
  const result = await api.get(`/type/show/${id}`);
  return result.data;
}
export async function updateCategory(category) {
  const result = await api.post(`/categories/update/${category.id}`, category);

  return result.data;
}

export async function updateType(type) {
  const result = await api.post(`/typeUpdate/${type.id}`, type);
  return result.data;
}

export async function searchCategory(query) {
  const result = await api.post("/categories/search", {
    nameCategory: query,
  });

  return result.data;
}

export async function searchType(query) {
  const result = await api.post("/type/search", {
    name: query,
  });

  return result.data;
}


export async function deleteNew(prod) {
  try {
    await api.delete(`/delete/new/editor/${prod.id}`);
  } catch (err) { }
}

export async function deleteTutorial(prod) {
  try {
    await api.delete(`/delete/tutorial/${prod.id}`);
  } catch (err) { }
}

export async function CreateTutorial(prod) {
  try {
    await api.get(`/tutoriaisCreate`);
  } catch (err) { }
}

export async function deleteTags(tagToRemove) {
  try {
    await api.delete(`/delete/tags/${tagToRemove.id}`);
    return { success: true };
  } catch (err) {
    return { success: false, error: err };
  }
}


export async function getAllNewsAdmin(page = 1) {
  const result = await api.get("/allNewsAdmin", {
    params: {
      page,
    },
  });
  return result.data;
}

export async function getAllNewsEditor(page = 1) {
  const result = await api.get("/news/editor", {
    params: {
      page,
    },
  });
  return result.data;
}

export async function searchNewsAdmin(query, page = 1) {
  const result = await api.post("/editor/admin/search", {
    nameNew: query,
    page,
  });

  return result.data;
}
export async function deletesProducts(id) {
  try {
    return await api.post(`/deleteNews`, {
      ids: id
    });
  } catch (err) { }
}

export async function deletesTutoriais(id) {
  try {
    return await api.post(`/deleteTutoriais`, {
      ids: id
    });
  } catch (err) { }
}

export async function duplicateOffer(prod) {
  try {
    return await api.post(`/duplacateNews`, {
      id: prod.id
    });
  } catch (err) { }
}

export async function searchNewsEditor(query, page = 1) {
  const result = await api.post("/news/editor/search", {
    nameNew: query,
    page,
  });

  return result.data;
}

export async function AddNewEditor(data) {
  try {
    await api.post("/new/editor", data);
    return { success: true };
  } catch (err) {
    return { success: false };
  }
}

export async function addTags(data) {
  try {
    const result = await api.post("/tags", data);
    return { success: true, tag: result.data };
  } catch (err) {
    return { success: false };
  }
}

export async function getNew(id) {
  const result = await api.get(`/new/editor/${id}`);
  return {
    ...result.data,
    type: "product",
  };
}

export async function getNewSlug(slug) {
  const result = await api.get(`new/show/${slug}`);
  return {
    ...result.data,
    type: "product",
  };
}
export async function updateNew(product) {
  try {
    await api.post(
      `/new/editor/update/${product.id}`,
      createProductFormData(product)
    );
    return true;
  } catch (err) {
    return false;
  }
}

export async function getHighlightedNews(type = null) {
  const query = type ? `?type=${type}` : '';
  const result = await api.get(`/topNews${query}`);
  return result.data;
}


export async function findNewsRecents() {
  const result = await api.get("/findNewsRecents");
  return result.data;
}
export async function findAnaRecents() {
  const result = await api.get("/findAnalisesRecents");
  return result.data;
}


export async function searchNewsInCategory(
  data,
  page = 1,
  ascOrDesc = "DESC"
) {
  const result = await api.post("/searchNews", data, {
    params: {
      page,
      ascOrDesc
    }
  });

  return result.data;

}
export async function searchAnalysisInCategory(
  data,
  page = 1,
  ascOrDesc = "DESC"
) {
  const result = await api.post("/searchAnalises", data, {
    params: {
      page,
      ascOrDesc
    }
  });

  return result.data;

}

export async function searchTutoriais(
  data,
  page = 1,
  ascOrDesc = "DESC"
) {
  const result = await api.post("/searchTutoriais", {
    name: data
  }, {
    params: {
      page,
      ascOrDesc
    }
  });

  return result.data;

}
export async function tutoriaisS(
  data,
  page = 1,
  ascOrDesc = "DESC"
) {
  const result = await api.post("/tutoriais", data, {
    params: {
      page,
      ascOrDesc
    }
  });
  return result.data;

}

export async function getAllRibbonBadges(page = 1) {
  const result = await api.get("/ribbonBadgesAll", {
    params: {
      page,
    },

  });
  return result.data;

}

export async function RibbonBadges(data) {
  const result = await api.post("/ribbonBadgesCad", data);

  return result.data;
}

export async function deleteRibbonDelete(cat) {
  try {
    await api.delete(`/ribbonBadgesDelete/${cat.id}`);
  } catch (err) { }
}

export async function getRibonBadges(id) {
  const result = await api.get(`/ribbonBadge/${id}`);

  return result.data;
}

export async function updateRibbonBadge(category) {
  const result = await api.post(`/ribbonBadgesUp/${category.id}`, category);

  return result.data;
}

export async function searchRibbonBadges(query) {
  const result = await api.post("/ribbonBadges/search", {
    name: query,
  });

  return result.data;
}
export async function deleteReview(review) {
  try {
    await api.delete(`/deleteReview/${review.id}`);
  } catch (err) { }
}
export async function getAllReviews(page = 1) {
  const result = await api.get("/reviewAll", {
    params: {
      page,
    },
  });

  return result.data;
}
export async function reviewProduct(review) {
  const result = await api.post("/evaluateTheProduct", review);

  return result.data;
}
export async function updateReview(id, review) {
  const result = await api.post(`/editReview/${id}`, review);

  return result.data;
}

export async function getProductReviews(id) {
  const result = await api.get(`/listReviews/${id}`);

  return result.data;
}
